export const selectMSTeamsContext = (state) => state.msTeamsContext.context;
